import actionTypes from "./actionTypes";
export default {
    setIsExpanded: (isExpanded) => ({
        type: actionTypes.SET_IS_EXPANDED,
        isExpanded
    })
};
